import { useRouter } from "next/router";
import { i18n, useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import ScrollButton from "../components/scroll_button";
import InfoSection from "../components/info_section";
import Layout from "../components/layout";
import Image from "next/image";
import styles from "../styles/mq.module.scss";
import MessageBroker from "../public/mq.webp";
import MqSecurity from "../public/mqSecurity.svg";
import Modal from "../components/contactUsModal";
import PossibilitiesTabs from "../components/possibilitiesTabs";
import { useState } from "react";

export default function Delivery() {
  const router = useRouter();
  const { t } = useTranslation("mq");
  const [clicked, setIsClicked] = useState(-1);

  return (
    <Layout title={t("metaTitle")} lang={router.locale} route={router.route} isHeader isFooter description={t("metaDescription")}>
      <ScrollButton scrollStepInPx="50" delayInMs="16.66" />
      <InfoSection title="Message Queue (MQ)" description="mqDescription" documentationLink="https://help.icdc.io/mq/" lang={router.locale} />

      <div className={styles.mq}>
        <section className={styles.whatIsIt}>
          <div className={styles.serviceImg}>
            <Image src={MessageBroker} alt="Message Broker" unoptimized loading='lazy' />
          </div>
          <h2>{t("whatIsService.title")}</h2>
          <p dangerouslySetInnerHTML={{ __html: t("whatIsService.description", { interpolation: { escapeValue: false } }) }} />
        </section>

        <section className={styles.features}>
          <h2>{t("features.title")}</h2>
          <div className={styles.features__grid}>
            {new Array(3).fill("").map((_, index) => (
              <div key={index} className={styles.features__item}>
                <div className={styles.features__item_header}>
                  <h3>{t(`features.title${index + 1}`)}</h3>
                </div>
                <p>{t(`features.description${index + 1}`)}</p>
              </div>
            ))}
          </div>
        </section>

        <PossibilitiesTabs dictionary={"mq"} tabsQuantity={10} isCenteredContent />

        <section className={styles.howItWorks}>
        <h2>{t("howItWorks.title")}</h2>
        <img
            src={i18n.language === "en" ? "/mq_en.webp" : "/mq_ru.webp"}
            alt="MQ"
            loading="lazy"
        />
        </section>

        <section className={styles.security}>
          <Image src={MqSecurity} alt="MQ Security" loading="lazy" />
          <div className={styles.security__content}>
            <h2>{t("security.title")}</h2>
            {new Array(3).fill("").map((_, index) => (
              <div key={index} className={styles.security__item}>
                <h3>{t(`security.subtitle${index + 1}`)}:</h3>
                <p>{t(`security.description${index + 1}`)}</p>
              </div>
            ))}
          </div>
        </section>
        
      <section className={styles.faq}>
        <h2>{t("faq.title")}</h2>
        <div className={styles.faq_wrapper}>
          {new Array(6).fill("").map((_, key) => (
            <button
              className={styles.faq_container}
              onClick={() =>
                clicked !== key ? setIsClicked(key) : setIsClicked(-1)
              }
              key={key}
            >
              <div className={styles.faq_titles + ' ' + (clicked === key ? styles.active : '')}>
                <b className={styles.title}>{t(`faq.question${key + 1}`)}</b>
                <img
                  className={
                    clicked !== key ? styles.purple_plus : styles.purple_minus
                  }
                  src={clicked !== key ? "/plus.svg" : "/minusFAQ.svg"}
                  alt="FAQ"
                />
              </div>
              {clicked === key && (
                <p className={styles.faq_answ}>{t(`faq.answer${key + 1}`)}</p>
              )}
            </button>
          ))}
        </div>
      </section>

        <section className={styles.questions}>
          <h2>{t("contact.title")}</h2>
          <p>{t("contact.desc")}</p>
          <Modal lang={router.locale} blue />
        </section>
      </div>
    </Layout>
  );
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ["mq", "common"])),
  },
});
